<template>
  <div>
    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <router-link to="/">
          <img :src="siteLogo" alt="" class="logo-login" />
        </router-link>
        <div class="kt-login__title login-title">
          <h3>{{ $t("ENTER_YOUR_NEW_PASSWORD") }}</h3>
        </div>

        <!--begin::Form-->
        <b-form class="kt-form login-form" @submit.stop.prevent="onSubmit">
          <div
            role="alert"
            v-bind:class="{ show: errors.length }"
            class="alert fade alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>

          <b-form-group id="email-input-group" label="" label-for="email-input">
            <b-form-input
              id="email-input"
              name="email"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="email-input-live-feedback"
              v-bind:placeholder="$t('EMAIL')"
            ></b-form-input>

            <b-form-invalid-feedback id="email-input-live-feedback">
              {{ $t("ENTER_VALID_EMAIL") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="password-input-group"
            label=""
            label-for="password-input"
          >
            <b-form-input
              type="password"
              id="password-input"
              name="password"
              v-bind:placeholder="$t('PASSWORD')"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="password-input-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="password-input-live-feedback">
              {{ $t("PASSWORD_IS_REQUIRED") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="password-input-group"
            label=""
            label-for="password-input"
          >
            <b-form-input
              type="password"
              id="password_confirmation-input"
              name="password_confirmation"
              v-bind:placeholder="$t('CONFIRM_PASSWORD')"
              v-model="$v.form.password_confirmation.$model"
              :state="validateState('password_confirmation')"
              aria-describedby="input-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="input-live-feedback">
              {{ $t("PASSWORDS_DO_NOT_MATCH") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <div class="kt-login__actions">
            <router-link to="/login">
              <a class="kt-link kt-login__link-forgot">
                {{ $t("LOGIN") }}
              </a>
            </router-link>

            <b-button
              type="submit"
              id="kt_submit"
              class="btn btn-success btn-elevate kt-login__btn-primary"
            >
              {{ $t("SAVE") }}
            </b-button>
          </div>
          <!--end::Action-->
          <!--end::Action-->
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped>
.kt-spinner.kt-spinner--right:before {
  right: 8px;
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import { RESET } from "@/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required, sameAs } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "reset",
  data() {
    return {
      form: {
        email: this.$route.params.email,
        password: "",
        password_confirmation: ""
      }
    };
  },
  mounted() {
    // check if current user is authenticated

    if (this.isAuthenticated) {
      this.$router.push({ name: "dashboard" });
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      password_confirmation: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: this.$route.params.email,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;
      const password_confirmation = this.$v.form.password_confirmation.$model;
      const token = this.$route.params.token;

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add(
        "kt-spinner",
        "kt-spinner--light",
        "kt-spinner--right"
      );

      // send login request
      this.$store
        .dispatch(RESET, {
          email: email,
          password: password,
          password_confirmation: password_confirmation,
          token: token
        })
        // go to which page after successfully login
        .then(() => {
          this.$router.push({ name: "dashboard" });
        })
        .finally(() => {
          submitButton.classList.remove(
            "kt-spinner",
            "kt-spinner--light",
            "kt-spinner--right"
          );
        });
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    ...mapState({
      errors: state => state.auth.errors
    }),
    siteLogo() {
      return process.env.BASE_URL + "assets/media/logos/logo.png";
    }
  }
};
</script>
